import { render, staticRenderFns } from "./AgreementBtn.vue?vue&type=template&id=9f6b4678&scoped=true"
import script from "./AgreementBtn.vue?vue&type=script&lang=js"
export * from "./AgreementBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6b4678",
  null
  
)

export default component.exports